export const PLACEHOLDER_LABEL_TEXT = 'Search transcript';
export const NO_RESULTS_TEXT = 'No results found';
